'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeHeaders = normalizeHeaders;
exports.lowerCaseHeaders = lowerCaseHeaders;
var isFn = exports.isFn = function isFn(fn) {
  return typeof fn === 'function';
};

var only = exports.only = function only(obj, keys) {
  obj = obj || {};
  if (typeof keys === 'string') keys = keys.split(/ +/);
  return keys.reduce(function (ret, key) {
    if (obj[key] == null) return ret;
    ret[key] = obj[key];
    return ret;
  }, {});
};

var mco = exports.mco = function mco(fns) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fns.reduce(function (ret, fn) {
    var nextRet = fn(ret);
    if (nextRet == null) return ret;
    return nextRet;
  }, data);
};

var noop = exports.noop = function noop() {};

var isPlainObject = exports.isPlainObject = function isPlainObject(obj) {
  return {}.toString.call(obj) === '[object Object]';
};

var isURLSearchParams = exports.isURLSearchParams = function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
};

var normalizeHeaderName = exports.normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  Object.keys(headers).forEach(function (name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = headers[name];
      delete headers[name];
    }
  });
};

function normalizeHeaders(headers) {
  if (headers == null) return {};

  var result = {};
  Object.keys(headers).forEach(function (key) {
    if (headers[key] == null) return;

    var keyParts = key.split('-').map(function (part) {
      return part[0].toUpperCase() + part.slice(1).toLowerCase();
    });

    result[keyParts.join('-')] = headers[key];
  });

  return result;
}

function lowerCaseHeaders(headers) {
  if (headers == null) return {};

  var result = {};
  Object.keys(headers).forEach(function (key) {
    result[key.toLowerCase()] = headers[key];
  });

  return result;
}

var random16Hex = exports.random16Hex = function random16Hex() {
  return (0x10000 | Math.random() * 0x10000).toString(16).substr(1);
};
var random64Hex = exports.random64Hex = function random64Hex() {
  return random16Hex() + random16Hex() + random16Hex() + random16Hex();
};

var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

var btoa = exports.btoa = function btoa(str) {
  str = String(str);

  var bitmap = void 0;
  var a = void 0;
  var b = void 0;
  var c = void 0;
  var result = '';
  var i = 0;
  var len = str.length;
  var rest = len % 3;

  for (; i < len;) {
    if ((a = str.charCodeAt(i++)) > 255 || (b = str.charCodeAt(i++)) > 255 || (c = str.charCodeAt(i++)) > 255) {
      throw new TypeError('Failed to execute \'btoa\' on \'Window\': The string to be encoded contains characters outside of the Latin1 range.');
    }

    bitmap = a << 16 | b << 8 | c;

    result += b64.charAt(bitmap >> 18 & 63) + b64.charAt(bitmap >> 12 & 63) + b64.charAt(bitmap >> 6 & 63) + b64.charAt(bitmap & 63);
  }

  return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result;
};